import React, { FC, memo } from 'react';
import { FieldArray } from 'formik';

import Draggable from './Draggable';
import { Props } from './types';

const Modifiers: FC<Props> = ({ brandId, items, isProcessing }) => {
  return (
    // @ts-ignore
    <FieldArray name="temporalItems">
      {({ unshift, remove, move, form }) => (
        <Draggable
          unshift={unshift}
          remove={remove}
          move={move}
          items={form.values.temporalItems}
          brandId={brandId}
          itemsMap={items}
          isProcessing={isProcessing}
        />
      )}
    </FieldArray>
  );
};

export default memo(Modifiers);
